// extracted by mini-css-extract-plugin
module.exports = {"notificationBadge":"WelcomeAlert-module--notificationBadge--2YOK8"};